import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Loader2, Trash2, Mail, Download } from "lucide-react";

// Elenco iscritti agli aggiornamenti stampa (testate/media che hanno lasciato l'email).
export function PressSubscribersTab() {
  const [subs, setSubs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/admin/lounge/press-subscribers")
      .then(({ data }) => setSubs(data.subscribers || []))
      .catch(() => setSubs([]))
      .finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    try { await api.delete(`/admin/lounge/press-subscribers/${id}`); load(); }
    catch (e) { toast.error(formatApiError(e?.response?.data?.detail)); }
  };

  const exportCsv = () => {
    const header = ["nome", "email", "testata", "lingua", "stato", "accreditato", "fonte", "data"];
    const rows = [header, ...subs.map((s) => [
      s.name, s.email, s.outlet, s.lang,
      s.confirmed ? "Confermato" : "In attesa",
      s.accredited ? "Sì" : "No",
      s.source, (s.created_at || "").slice(0, 10),
    ])];
    const csv = rows.map((r) => r.map((v) => `"${String(v || "").replace(/"/g, '""')}"`).join(",")).join("\n");
    const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = "iscritti-accreditati-stampa.csv";
    a.click();
  };

  if (loading) return <div className="flex items-center gap-2 py-10 text-muted-foreground"><Loader2 className="h-4 w-4 animate-spin" /> Caricamento…</div>;

  return (
    <div className="space-y-4" data-testid="press-subscribers-tab">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Mail className="h-4 w-4 text-brema-red" />
          <h3 className="text-lg font-semibold">Iscritti agli aggiornamenti stampa <span className="text-muted-foreground">({subs.length})</span></h3>
        </div>
        {subs.length > 0 && (
          <Button variant="outline" size="sm" onClick={exportCsv} data-testid="subscribers-export-btn"><Download className="mr-1.5 h-4 w-4" /> Esporta CSV</Button>
        )}
      </div>

      {subs.length === 0 ? (
        <p className="rounded-xl border border-border bg-brema-card p-6 text-sm text-muted-foreground" data-testid="subscribers-empty">Nessun iscritto al momento.</p>
      ) : (
        <div className="overflow-hidden rounded-xl border border-border">
          <table className="w-full text-sm">
            <thead className="bg-brema-card text-left text-xs uppercase tracking-wide text-muted-foreground">
              <tr>
                <th className="px-4 py-2.5">Nome</th>
                <th className="px-4 py-2.5">Email</th>
                <th className="px-4 py-2.5">Testata / Media</th>
                <th className="px-4 py-2.5">Lingua</th>
                <th className="px-4 py-2.5">Stato</th>
                <th className="px-4 py-2.5">Data</th>
                <th className="px-4 py-2.5" />
              </tr>
            </thead>
            <tbody>
              {subs.map((s) => (
                <tr key={s.id} className="border-t border-border" data-testid={`subscriber-row-${s.id}`}>
                  <td className="px-4 py-2.5 font-medium text-foreground">{s.name || "—"}</td>
                  <td className="px-4 py-2.5 text-muted-foreground">{s.email}</td>
                  <td className="px-4 py-2.5 text-muted-foreground">{s.outlet || "—"}</td>
                  <td className="px-4 py-2.5 uppercase text-muted-foreground">{s.lang || "—"}</td>
                  <td className="px-4 py-2.5">
                    {s.confirmed
                      ? <span className="inline-flex items-center rounded-full bg-emerald-500/15 px-2 py-0.5 text-xs font-semibold text-emerald-600" data-testid={`subscriber-confirmed-${s.id}`}>Confermato</span>
                      : <span className="inline-flex items-center rounded-full bg-amber-500/15 px-2 py-0.5 text-xs font-semibold text-amber-600" data-testid={`subscriber-pending-${s.id}`}>In attesa</span>}
                  </td>
                  <td className="px-4 py-2.5 text-muted-foreground">{(s.created_at || "").slice(0, 10)}</td>
                  <td className="px-4 py-2.5 text-right">
                    <Button variant="ghost" size="sm" onClick={() => del(s.id)} data-testid={`subscriber-delete-${s.id}`}><Trash2 className="h-4 w-4 text-brema-red" /></Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
